import { createSelector } from 'reselect'
import {
  entitySelector
} from 'containers/Entity/selectors'
import * as R from 'ramda'
import P from 'helpers/predicates'

const detailIdStateSelector = state => state.product.view.detailId

const detailsSelector = createSelector(
  entitySelector,
  detailIdStateSelector,
  (entities, id) => P.isNotNil(id) && entities['details']
    ? entities['details'][id]
    : {}
)

const createDetailSelector = prop => createSelector(
  detailsSelector,
  R.prop(prop)
)

const idSelector = createDetailSelector('id')

export {
  detailsSelector,
  detailIdStateSelector,
  idSelector
}
